import { userSignedOutAction } from "../actions";
import { connect } from "react-redux";
import HeaderBar from "../../header/HeaderBar";

const mapStateToProps = (state) => {
    const { isAuthenticated, user } = state;
    return { isAuthenticated, user }
};

const mapDispatchToProps = dispatch => {
    return {
        reportUserSignedOut: () => {
            dispatch( userSignedOutAction() )
        }
    }
};

export const HeaderBarAdapter = connect(mapStateToProps, mapDispatchToProps)(HeaderBar);